import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Sun, Moon } from 'lucide-react';
export function Mechanism() {
  return <section className="py-24 px-6" data-id="element-73">
      <div className="max-w-5xl mx-auto" data-id="element-74">
        <FadeIn className="text-center max-w-3xl mx-auto mb-16" data-id="element-75">
          <span className="text-sm font-bold tracking-widest uppercase text-[#C26D5C] mb-4 block" data-id="element-76">
            El Mecanismo Único
          </span>
          <h2 className="font-serif text-3xl md:text-5xl mb-6 text-[#1C1917]" data-id="element-77">
            El Método de Micro-Sincronización (Am/Pm)
          </h2>
          <p className="text-xl text-[#4A4541] leading-relaxed" data-id="element-78">
            Este sistema no es una práctica espiritual; es una interrupción
            química. Utilizamos ventanas de 300 segundos para enviar señales
            directas al sistema nervioso.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-79">
          <FadeIn delay={0.1} direction="right" data-id="element-80">
            <div className="bg-[#FAF7F2] border border-[#E5E0D8] p-8 md:p-10 rounded-sm h-full relative overflow-hidden group" data-id="element-81">
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#C26D5C]/5 rounded-bl-full -mr-16 -mt-16 transition-transform group-hover:scale-110 duration-700" data-id="element-82"></div>
              <Sun className="w-8 h-8 text-[#C26D5C] mb-6 relative z-10" strokeWidth={1.5} data-id="element-83" />
              <h3 className="font-serif text-2xl mb-4 text-[#1C1917] relative z-10" data-id="element-84">
                En la mañana
              </h3>
              <p className="text-[#4A4541] text-lg leading-relaxed relative z-10" data-id="element-85">
                Activamos la dopamina y oxigenamos la sangre. Diseñado para
                anular el pico de cortisol agresivo y darte enfoque inmediato
                sin ansiedad.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} direction="left" data-id="element-86">
            <div className="bg-[#2A3439] text-[#FAF7F2] p-8 md:p-10 rounded-sm h-full relative overflow-hidden group" data-id="element-87">
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-bl-full -mr-16 -mt-16 transition-transform group-hover:scale-110 duration-700" data-id="element-88"></div>
              <Moon className="w-8 h-8 text-[#8BA3AB] mb-6 relative z-10" strokeWidth={1.5} data-id="element-89" />
              <h3 className="font-serif text-2xl mb-4 text-white relative z-10" data-id="element-90">
                En la noche
              </h3>
              <p className="text-[#D1D5D6] text-lg leading-relaxed relative z-10" data-id="element-91">
                Forzamos la liberación de GABA para inducir un cierre mental
                absoluto. Apagamos la rumiación nocturna para un descanso
                profundo.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} className="text-center mt-12" data-id="element-92">
          <p className="text-lg font-medium text-[#1C1917] italic" data-id="element-93">
            "Es precisión neuroquímica aplicada a tu reloj despertador."
          </p>
        </FadeIn>
      </div>
    </section>;
}